import { Dialog } from '@capacitor/dialog';
import { useTranslate } from '@tolgee/react';
import { useAuth } from 'lincd-auth/lib/hooks/useAuth';
import { Team } from 'lincd-irlcg/lib/shapes/Team';
import { Button } from 'lincd-mui-base/lib/components/Button';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from '../layout/Container';
import { DefaultLayout } from '../layout/DefaultLayout';
import { ROUTES } from '../routes';
import './AttendanceSelect.scss';
import style from './AttendanceSelect.scss.json';
import { Player } from 'lincd-irlcg/lib/shapes/Player';
import Header from '../components/molecules/Header';
import { UserAccount } from 'profile-plus/lib/shapes/UserAccount';

function SetAttencence() {
  let { t } = useTranslate();
  let prefix = 'attendenceSelect';
  const navigate = useNavigate();
  let [loading, setLoading] = useState(false);
  const auth = useAuth<Player, UserAccount>();
  const user = auth.user;

  return (
    <DefaultLayout backgroundColor={'gray'}>
      <Header title={t(prefix + '.header', 'ATTENDENCE')} inverted={true} />
      <Container maxWidth={'sm'}>
        <div className={style.content}>
          <p>How will you be attending this event?</p>
          <div className={style.attendanceButtons}>
            <Button
              onClick={() => {
                if (user) {
                  user.attendance = 'inPerson';
                  navigate(ROUTES.index.path);
                }
              }}
              variant={'filled'}
              className={style.buttonAttendence}
              color={'primary'}
              aria-label={t(prefix + '.attendenceButtonInPerson', 'In-Person')}
            >
              In-Person
            </Button>
            <Button
              onClick={() => {
                if (user) {
                  user.attendance = 'home';
                  navigate(ROUTES.index.path);
                }
              }}
              variant={'filled'}
              className={style.buttonAttendence}
              color={'primary'}
              aria-label={t(prefix + '.attendenceButtonHome', 'Home')}
            >
              Home
            </Button>
          </div>
        </div>
      </Container>
    </DefaultLayout>
  );
}

export default SetAttencence;
